module.exports = __webpack_public_path__ + "static/r25-ecc4c8ce7266bd02a59c4225d3de9ff7.jpg";